export default __webpack_public_path__ + "static/media/lithuania.0768ed33.png";